import React from "react";
import { ReactComponent as JameoLogoSVG } from "./../../assets/images/jameo_logo.svg";
import styles from "./JameoLogo.module.scss";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { ROUTES } from "../../utils/Constant";

export const LOGO_SIZE_ENUM = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
};

export const JameoLogo = (props) => {
  //Expects a value of LOGO_SIZE_ENUM for size
  const { size, className, ...logoProps } = props;

  return (
    <Link to={ROUTES.HOME}>
      <JameoLogoSVG
        className={classNames(styles.logo, styles[size], className)}
        {...logoProps}
      />
    </Link>
  );
};

export const JameoLogoMedium = (props) => {
  return (
    <span>
      <JameoLogo size={LOGO_SIZE_ENUM.MEDIUM} {...props} />
    </span>
  );
};

//Default value
JameoLogo.defaultProps = {
  size: LOGO_SIZE_ENUM.SMALL,
};
